import { createApp } from "vue";
import App from "./App.vue";
import routerPromise from "./router";
import store from "./store";
import PrimeVue from "primevue/config";
import configuration from "./configuration.js"
import "primevue/resources/themes/md-light-indigo/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import VueClickAway from "vue3-click-away";
import "bootstrap/dist/css/bootstrap.min.css";

import i18n from "./common/plugins/i18n";
import { setDirectives } from "./directive";
import ToastService from "primevue/toastservice";
import translation, { websiteText } from "./translations";
import { SET_DEFAULT_LANGUAGE_AND_CURRENCY } from "./common/store/action.js";
import { GET_BILLING_COMPANY } from "./domains/checkout/store/actions.js";

// import createRoutes from "./router";
// import { createMetaManager } from "vue-meta";

function refreshTokenBeforeMount()
{
    return store.dispatch("REFRESH_TOKEN")
}

async function mount(){
    await store.dispatch(SET_DEFAULT_LANGUAGE_AND_CURRENCY)
    await store.dispatch(GET_BILLING_COMPANY)   
    const router = await routerPromise
    refreshTokenBeforeMount().finally(
        async ()=>{
            const app = createApp(App)
                .use(store)
                // .use(i18n)
                .use(router)
                // .use(createMetaManager())
                .use(PrimeVue, { ripple: true });

            app.use(VueClickAway);
            app.use(ToastService);
            setDirectives(app);
            app.config.globalProperties.$config = configuration
            app.config.globalProperties.$translation = translation
            app.config.globalProperties.$websiteText = websiteText
            app.mount("#app");
        }
    )
    
}

mount()
